import styled, {css} from "styled-components";
import {FaExchangeAlt} from "react-icons/fa";
import {FlexBetween, FlexCenter} from "../CommonStyles";

const ChangePairIcon = styled(FaExchangeAlt)`
  color: ${props => props.theme.color};
  margin-top: -3px;
`

const RTradeCompWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${props => props.theme.tradeBg};
  padding: 10px 0;
  direction: ltr;
`

const CoinWrap = styled.div`
  position: absolute;
  top: ${props => props.top || 0};
  left: ${props => props.left || 0};
  z-index: ${props => props.zIndex || 1};
`

const OrderRow = styled(FlexBetween)`
  border-bottom: 1px solid ${props => props.theme.color}20;
  height: unset;
`


export {
    ChangePairIcon,
    RTradeCompWrap,
    CoinWrap,
    OrderRow
}